// What the news pages have already loaded, kept for the session so switching tabs is instant.
const store = new Map();
const FRESH_FOR = 10 * 60 * 1000;

export const remember = (key, value) => store.set(key, { value, at: Date.now() });

export const recall = (key) => {
  const hit = store.get(key);
  if (!hit) return null;
  if (Date.now() - hit.at > FRESH_FOR) {
    store.delete(key);
    return null;
  }
  return hit.value;
};

export const forget = (key) => store.delete(key);
